import { render } from "./AllTasks.vue?vue&type=template&id=8c328dcc&scoped=true"
import script from "./AllTasks.vue?vue&type=script&lang=js"
export * from "./AllTasks.vue?vue&type=script&lang=js"

import "./AllTasks.vue?vue&type=style&index=0&id=8c328dcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c328dcc"]])

export default __exports__